import {detect} from "detect-browser";
const browser = detect();

export function isSupported(fallbackFunc, useWhitelist) {
    let whiteList = [
        "chrome", "firefox", "edge-chromium", "chromium-webview", "opera", "android", "ios", "safari", "searchbot", "edge", "crios", "fxios", "samsung"
    ];

    let blackList = [
        "aol", "yandexbrowser", "kakaotalk", "silk", "miui", "beaker", "opera-mini", "ie", "bb10"
    ];

    if (browser) {
        let found = false;
        let arr = useWhitelist ? whiteList : blackList;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === browser.name) {
                found = true;
            }
        }
        if (found && useWhitelist || !found && !useWhitelist) {
            return true;
        } else if (found && !useWhitelist || !found && useWhitelist) {
            console.warn("Unsupported browser");
            fallbackFunc();
            return false;
        } else {
            console.warn("Unsupported browser");
            fallbackFunc();
            return false;
        }
    } else {
        console.warn("Unsupported browser");
        fallbackFunc();
        return false;
    }
}


